import { AuthRouterPathEnum } from '@shared/enums';

export const AuthRouteSuccessMessageMap = {
  [AuthRouterPathEnum.RegisterSuccess]: 'auth.email.message.success',
  [AuthRouterPathEnum.PasswordResetSuccess]: 'auth.password-reset.message.success',
  [AuthRouterPathEnum.PasswordChangeSuccess]: 'auth.password-change.message.success',
  [AuthRouterPathEnum.ResendVerificationEmailSuccess]: 'auth.resend-verification-email.message.success'
};
